module.exports = __webpack_public_path__ + "img/normal_multiplier.622ef305.png";